import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
// Measured on a canvas rather than a <span> appended to <body>: reading clientWidth off a
// live node forced a full-document style recalc and layout on every call.
var context = document.createElement("canvas").getContext("2d");
export function getTextWidth(text) {
  var _context;
  var fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "14px";
  var fontWeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "regular";
  if (!context) return 0;

  // "regular" is not a valid CSS weight, and an invalid token voids the whole shorthand.
  var weight = fontWeight === "regular" ? "normal" : fontWeight;
  context.font = _concatInstanceProperty(_context = "".concat(weight, " ")).call(_context, fontSize, " Inter");
  return Math.ceil(context.measureText(text).width);
}